import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized401',
  templateUrl: './unauthorized401.component.html',
  styleUrls: ['./unauthorized401.component.scss']
})
export class Unauthorized401Component {

}
